<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="闯关模式：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="考试闯关" :value="1"></el-option>
              <el-option label="学习闯关" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
            <el-button @click="handleBack" plain size="mini">返回上一页</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建阶段</el-button>
          <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="闯关阶段" prop="stageNum" align="center" />
        <el-table-column label="闯关内容" prop="" align="center">
          <template slot-scope="{row}">
            {{row.courseSubjectList.length > 0?'课程':''}}{{row.courseScenarioExerciseList.length > 0 && row.courseSubjectList.length > 0?'，':''}}{{row.courseScenarioExerciseList.length > 0?'情景练习':''}}
          </template>
        </el-table-column>
        <el-table-column label="闯关模式" prop="" align="center">
          <template slot-scope="{row}">
            {{row.type === 1?'考试闯关':'学习闯关'}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="260">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <challenge-edit ref="challengeEdit" :rowItem="rowItem" @created="doQueryList({})" />
  </div>
</template>

<script>
import challengeEdit from './edit'
import courseSubjectBarrierStageApi from '@/api/course/courseSubjectBarrierStage'
import Pagination from '@/components/Pagination'

export default {
  props: ['rowItem'],
  components: {
    Pagination,
    challengeEdit
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.barrierId = this.rowItem.id
      this.listLoading = true
      return courseSubjectBarrierStageApi.fetchList(this.query)
        .then(data => {
          this.list = data.data
          // this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectBarrierStageApi.batchDeleted({ id: [row.id], deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectBarrierStageApi.batchDeleted({ id: this.selectItems.map(row => row.id), deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 2)
      }
    },
    beforeHandleCommand1(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand1(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 2)
      }
    },
    changeSwitch(row) {
      courseSubjectBarrierStageApi.batchState({ idList: row.id, state: row.state ? 1 : 0 }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.challengeEdit.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.challengeEdit.handleUpdate(row)
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>